<prism-select 
  [selectOptions]="options"
  [label]="label"
  [placeHolder]="multiSelect ? 'Select District(s)' : 'Select a District'"
  [control]="control"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="true"
  [labelClass]="labelClass"
  (onSelected)="emitOrganization($event)"
  [multiSelect]="multiSelect">
</prism-select>
